import api from "./instance";

export default {
  uploadImageWithLink: (body, token) =>
    api
      .post(`/file/link-upload`, body, {
        headers: { Authorization: token }
      })
      .then(res => res),
  uploadImageWithFile: (body, token) =>
    api
      .post(`/file/upload`, body, {
        headers: { Authorization: token }
      })
      .then(res => res)
};
